<template>
  <component ref="root" :is="tagType" class="intersection-observer">
    <slot></slot>
  </component>
</template>

<script setup>
const props = defineProps({
  /**
   * root 周囲のマージン（ターゲット交差対象であるビューポートの余白）
   */
  rootMargin: {
    type: String,
    default: '0%',
  },
  /**
   * ターゲットが見えている割合
   */
  threshold: {
    type: Number,
    default: 1.0,
  },
  /**
   * 監視の有効状態
   */
  active: {
    type: Boolean,
    default: true,
  },
  /**
   * 監視の遅延開始モード（指示があるまで開始を待つ）
   */
  delayedActivation: {
    type: Boolean,
    default: false,
  },
  /**
   * 監視開始（遅延開始モード時のみ使用）
   */
  doActivate: {
    type: Boolean,
    default: false,
  },
  /**
   * タグの種類
   */
  tagType: {
    type: String,
    default: 'div',
  },
})

const emit = defineEmits(['intersect'])

const isIntersected = ref(false)
const thisObserver = ref(null)
const root = ref(null)

watch(() => props.doActivate, (newValue, oldValue) => {
  if (newValue && props.delayedActivation) {
    observeIntersect()
  }
})
  
onMounted(() => {
  if (props.active && !props.delayedActivation) {
    observeIntersect()
  }
}) 

const observeIntersect = () => {
  const options = {
    root: null,
    rootMargin: props.rootMargin,
    threshold: props.threshold,
  }
  const handleIntersect = (entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting && !props.isIntersected) {
        emitIntersect()
        isIntersected.value = true
        thisObserver.value.disconnect()
      }
    })
  }
  thisObserver.value = new IntersectionObserver(handleIntersect, options)
  thisObserver.value.observe(root.value)
}

const emitIntersect = () => {
  emit('intersect')
}
</script>
